const CUSTOMER_DISPLAY_TAB_ID_PRESENCE_PREFIX =
  'customerDisplayTabIdentityPresence'
const CUSTOMER_DISPLAY_TAB_ID_PRESENCE_HEARTBEAT_MS = 60000
const CUSTOMER_DISPLAY_TAB_ID_PRESENCE_RETENTION_MS = 7 * 24 * 60 * 60 * 1000

const getCustomerDisplayTabIdPresenceKey = tabId =>
  `${CUSTOMER_DISPLAY_TAB_ID_PRESENCE_PREFIX}:${tabId}`

const parseCustomerDisplayTabIdPresence = value => {
  if (!value) return null

  try {
    const presence = JSON.parse(value)
    return typeof presence?.instanceId === 'string' &&
      typeof presence?.updatedAt === 'number'
      ? presence
      : null
  } catch {
    return null
  }
}

const getCustomerDisplayTabIdPresence = tabId => {
  try {
    const value = globalThis.localStorage?.getItem(
      getCustomerDisplayTabIdPresenceKey(tabId)
    )
    return parseCustomerDisplayTabIdPresence(value)
  } catch (error) {
    console.warn(
      'No se pudo leer la presencia de la pestaña para Customer Display:',
      error
    )
    return null
  }
}

export const createCustomerDisplayTabIdentityPresence = ({
  getTabId,
  instanceId,
}) => {
  let heartbeatInterval = null

  const hasForeignPresence = tabId => {
    const presence = getCustomerDisplayTabIdPresence(tabId)

    return Boolean(presence && presence.instanceId !== instanceId)
  }

  const cleanupAbandonedPresences = () => {
    const storage = globalThis.localStorage
    if (!storage) return

    try {
      const now = Date.now()

      for (let index = storage.length - 1; index >= 0; index -= 1) {
        const key = storage.key(index)
        if (!key?.startsWith(`${CUSTOMER_DISPLAY_TAB_ID_PRESENCE_PREFIX}:`)) {
          continue
        }

        const presence = parseCustomerDisplayTabIdPresence(storage.getItem(key))
        const shouldRemove =
          !presence?.instanceId ||
          typeof presence.updatedAt !== 'number' ||
          now - presence.updatedAt >
            CUSTOMER_DISPLAY_TAB_ID_PRESENCE_RETENTION_MS

        if (shouldRemove) {
          storage.removeItem(key)
        }
      }
    } catch (error) {
      console.warn(
        'No se pudieron limpiar las presencias antiguas de Customer Display:',
        error
      )
    }
  }

  const refresh = () => {
    const tabId = getTabId()
    if (!tabId) return

    try {
      globalThis.localStorage?.setItem(
        getCustomerDisplayTabIdPresenceKey(tabId),
        JSON.stringify({
          instanceId,
          updatedAt: Date.now(),
        })
      )
    } catch (error) {
      console.warn(
        'No se pudo registrar la presencia de la pestaña para Customer Display:',
        error
      )
    }
  }

  const handleStorageChange = event => {
    const tabId = getTabId()
    if (!tabId) return

    const presenceKey = getCustomerDisplayTabIdPresenceKey(tabId)
    const presenceWasCleared =
      event.key === null || (event.key === presenceKey && !event.newValue)

    if (presenceWasCleared) {
      refresh()
    }
  }

  const start = () => {
    cleanupAbandonedPresences()
    refresh()

    if (heartbeatInterval) {
      globalThis.clearInterval(heartbeatInterval)
    }

    heartbeatInterval = globalThis.setInterval(
      refresh,
      CUSTOMER_DISPLAY_TAB_ID_PRESENCE_HEARTBEAT_MS
    )
  }

  const release = () => {
    if (heartbeatInterval) {
      globalThis.clearInterval(heartbeatInterval)
      heartbeatInterval = null
    }

    const tabId = getTabId()
    if (!tabId) return

    try {
      const presence = getCustomerDisplayTabIdPresence(tabId)

      if (presence?.instanceId === instanceId) {
        globalThis.localStorage?.removeItem(
          getCustomerDisplayTabIdPresenceKey(tabId)
        )
      }
    } catch (error) {
      console.warn(
        'No se pudo limpiar la presencia de la pestaña para Customer Display:',
        error
      )
    }
  }

  return {
    handleStorageChange,
    hasForeignPresence,
    refresh,
    release,
    start,
  }
}
